import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { MeiliIndex } from '../SearchField/types';
import { SMLImage } from '../SMLImage';
import { PaletteResult } from './usePaletteSearch';
import { commandPaletteMessages as messages } from './commandPaletteMessages';
import styles from './PaletteResultRow.module.scss';

interface PaletteResultRowProps {
  result: PaletteResult;
  selected: boolean;
  onPick: () => void;
  onHover: () => void;
}

const TYPE_LABEL: Record<MeiliIndex, MessageDescriptor> = {
  [MeiliIndex.artists]: messages.typeArtist,
  [MeiliIndex.tracks]: messages.typeTrack,
  [MeiliIndex.playlists]: messages.typePlaylist,
};

/** An artist, a track or a playlist in the palette. */
const PaletteResultRowComponent: React.FC<PaletteResultRowProps> = ({ result, selected, onPick, onHover }) => {
  const intl = useIntl();
  const { searchItem } = result;
  return (
    <button
      type="button"
      className={clsx(styles.resultItem, selected && styles.resultItemSelected)}
      onClick={onPick}
      onMouseEnter={onHover}
    >
      <SMLImage
        src={searchItem.image}
        alt={searchItem.title}
        width={32}
        makeSquareFit
        className={searchItem.isImageRound === true ? styles.resultImageRound : styles.resultImageSquare}
      />
      <div className={styles.resultText}>
        <div className={styles.resultTitle}>{searchItem.title}</div>
        {searchItem.subtitle !== undefined && <div className={styles.resultSubtitle}>{searchItem.subtitle}</div>}
      </div>
      <span className={styles.resultType}>{intl.formatMessage(TYPE_LABEL[result.item.type])}</span>
    </button>
  );
};

export const PaletteResultRow = TypedMemo(PaletteResultRowComponent);
